module.exports = __webpack_public_path__ + "static/media/newDatePicker.9b579ecc.svg";